
import { useState } from 'react';

export default function PartnershipFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'What is the minimum investment required for partnership?',
      answer: 'The minimum investment for Strategic Partnership is $250,000. This provides 5-10% equity ownership and access to all partner benefits including profit distributions and exclusive opportunities.'
    },
    {
      question: 'How are profits distributed to partners?',
      answer: 'Profit distributions are made based on your equity percentage. Strategic Partners receive quarterly distributions, Executive Partners receive monthly distributions, and Founding Partners receive weekly distributions.'
    },
    {
      question: 'What level of involvement is expected from partners?',
      answer: 'Involvement varies by partnership tier. Strategic Partners participate in quarterly advisory meetings, Executive Partners have monthly strategic input, and Founding Partners have weekly operational involvement and decision-making authority.'
    },
    {
      question: 'Are there any geographic restrictions for partnerships?',
      answer: 'No geographic restrictions exist for partnerships. We welcome international partners and have expansion opportunities across North America, Europe, and select international markets.'
    },
    {
      question: 'How is the company valued for partnership equity?',
      answer: 'Company valuation is conducted by independent third-party appraisers using industry-standard methods including asset valuation, revenue multiples, and comparable company analysis. Current valuation is updated quarterly.'
    },
    {
      question: 'What happens if I want to exit my partnership?',
      answer: 'Partnership agreements include exit clauses with right of first refusal for existing partners. Exit valuations are conducted by independent appraisers, and we facilitate smooth transitions for departing partners.'
    },
    {
      question: 'Do partners have voting rights in company decisions?',
      answer: 'Yes, voting rights are proportional to equity ownership. Strategic Partners have advisory voting, Executive Partners have operational voting rights, and Founding Partners have full voting rights on all major decisions.'
    },
    {
      question: 'What kind of returns can partners expect?',
      answer: 'Historical returns range from 12-35% annually depending on partnership tier and market conditions. Returns come from profit distributions, property appreciation, and equity value growth.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Partnership FAQ</h2>
          <p className="text-xl text-gray-600">
            Common questions about OED partnership opportunities
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-gray-50 rounded-lg">
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <span className="font-semibold text-gray-900">{faq.question}</span>
                <i className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-emerald-600 text-xl`}></i>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-4">
                  <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">
            Have more questions about partnership opportunities?
          </p>
          <a
            href="/contact"
            className="inline-flex items-center text-emerald-600 hover:text-emerald-700 font-semibold cursor-pointer"
          >
            Contact our partnership team
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
